import PropTypes from 'prop-types'

const SpaceLandingDocumentation = ({ children }: any) => <div className="space-page-landing-docs">{children}</div>

SpaceLandingDocumentation.displayName = 'SpaceLandingDocumentation'

SpaceLandingDocumentation.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)])
}

SpaceLandingDocumentation.defaultProps = {
  children: null
}

export default SpaceLandingDocumentation
